import React from 'react';
import { PDFDocument } from 'pdf-lib';
import PdfDropzone from '../../components/pdf-drop-zone/pdf-drop-zone';
import { fileToArrayBuffer } from '@/utils/file-to-arraybuffer';
import { toast } from '@/components/toast/toast';
import { describeError } from '@/utils/describe-error';

type DocumentUploadProps = {
	onUploadDocument: () => void;
	setDocumentToSign: (document: File | null) => void;
};

const DocumentUpload: React.FC<DocumentUploadProps> = ({
	onUploadDocument,
	setDocumentToSign,
}) => {
	// Signing later loads the file with pdf-lib, so reject here what pdf-lib cannot
	// open (corrupt or encrypted PDFs) instead of letting the user annotate it first.
	const assertLoadablePdf = async (file?: File) => {
		const arrayBuffer = await fileToArrayBuffer(file);
		if (!arrayBuffer) throw new Error('File cannot be read');
		await PDFDocument.load(arrayBuffer);
	};

	const handleFileChange = (selectedFile?: File) => {
		if (selectedFile) {
			assertLoadablePdf(selectedFile)
				.then(() => {
					setDocumentToSign(selectedFile);
					onUploadDocument();
				})
				.catch((error) => {
					console.debug(error);
					toast({
						mode: 'destructive',
						description: `No pudimos abrir el PDF (${describeError(error)})`,
					});
				});
		}
	};

	return (
		<div data-tour="upload-dropzone">
			<PdfDropzone
				label="Sube un nuevo documento"
				hint="Haz clic o arrastra y suelta para subir"
				onFileSelected={handleFileChange}
			/>
		</div>
	);
};

export default DocumentUpload;
